import { render, staticRenderFns } from "./casedata.vue?vue&type=template&id=bce1c580"
import script from "./casedata.vue?vue&type=script&lang=js"
export * from "./casedata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports